import { Box, Chip, Grid } from '@material-ui/core';
import { useEntity, EntityRefLink } from '@backstage/plugin-catalog-react';
import { GraphQLSnippet } from './GraphQLSnippet';

/** Widget for `type: graphql-subgraph` — shows supergraph link + syntax-highlighted SDL. */
export function SubgraphDefinitionWidget({
  definition,
}: {
  definition: string;
}) {
  const { entity } = useEntity();
  const partOf = (entity.spec as any)?.partOf as string | undefined;

  return (
    <Grid container spacing={2}>
      {partOf && (
        <Grid item xs={12}>
          <Box display="flex" alignItems="center" gridGap={8}>
            <Chip
              label={
                <EntityRefLink entityRef={`api:default/${partOf}`}>
                  Supergraph: {partOf}
                </EntityRefLink>
              }
              size="small"
              color="primary"
              variant="outlined"
            />
          </Box>
        </Grid>
      )}
      <Grid item xs={12}>
        <GraphQLSnippet text={definition} />
      </Grid>
    </Grid>
  );
}
